import { LockDirective } from 'src/app/share/directive/lock-until.directive';
import { isNullOrUndefined } from 'util';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { CommonHttpClientService } from 'src/app/share/service/common-http-client.service';
import { Directive, HostListener, Inject, Input } from '@angular/core';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';

/** banner被點擊的事件 */
@Directive({
  selector: '[appBannerHit]'
})
export class BannerHitDirective {
  @Input() id: number;
  @Input() lock: LockDirective;
  /** api url. 被點擊的banner在首頁還是主題頁 */
  @Input() url: 'site' | 'theme';

  constructor(
    private http: CommonHttpClientService,
    @Inject(GENERATOR_ENV_TOKEN) private generatorEnv: GeneratorEnv,
    private serverConfigService: ServerConfigService
  ) { }

  ngOnInit(): void {
    if (isNullOrUndefined(this.id)) {
      console.error('appBannerHit: 請傳入id');
    }
  }

  @HostListener('click') bannerHit() {
    if (this.lock && this.lock.isLock) {
      return;
    }
    this.lock.lock();
    this.http.post<any>(`${this.generatorEnv.apiHost}/api/${this.url}/${this.serverConfigService.config.lang}/banner/${this.id}`,{}).subscribe(() => {
      this.lock.unlock();
    });
  }
}
